import styles from './NumberToggle.module.scss'
import { useEffect, useState } from 'react'

interface Props {
  value: number
  onChange?: (value: number, action: 'increase' | 'decrease') => void
  step?: number
  minValue?: number
  maxValue?: number
  disabled?: boolean
  increaseDisabled?: boolean
}

const NumberToggle = ({ value, onChange = () => {}, step = 1, minValue = 0, maxValue, disabled = false, increaseDisabled = false }: Props) => {
  // const [value, setValue] = useState<number>(initialValue)

  // useEffect(() => {
  //   setValue(initialValue)
  // }, [initialValue])

  const handleDecrease = () => {
    if (value > minValue) {
      // setValue(value - step)
      onChange(value - step, 'decrease')
    }
  }
  const handleIncrease = () => {
    // setValue(value + step)
    onChange(value + step, 'increase')
  }

  return (
    <div className={styles.root}>
      <div className={`${styles.button} ${value === minValue || disabled ? styles.disabled : ''}`} onClick={handleDecrease}>
        -
      </div>
      <div className={`${styles.value} ${disabled ? styles.disabled : ''}`}>{value}</div>
      <div className={`${styles.button} ${value === maxValue || increaseDisabled || disabled ? styles.disabled : ''}`} onClick={handleIncrease}>
        +
      </div>
    </div>
  )
}

export default NumberToggle
